/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { NodeStatus } from '../../pages/ClusterPage/components/NodeStatus';
import { EntityId } from '../api/EntityId';
import { ClusterStorageResponsePayload } from './ClusterStorageResponsePayload';

export enum ClusterNodeListRole {
  primary = 'primary',
  replica = 'replica',
}

export interface ClusterNodeListResponsePayload {
  id: EntityId;
  status: NodeStatus;
  role: ClusterNodeListRole;
  lag?: string;
  storage: ClusterStorageResponsePayload;
}
